import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ListIcon from "@mui/icons-material/List";
import ListBrowser, { getListBrowserStore } from "@ts-private/list-browser";
import { useApolloFetching } from "@ts-private/list-browser-apollo-extensions";
import { Card } from "@totalsoft/rocket-ui";
import ListItem from "./ListItem";
import { PARTNER_LIST_QUERY } from "../queries";
import { useListBrowserFunctions } from "hooks/useListBrowserFunctions";
import { withParams } from "providers/ParamsConsumer";

const bankListStore = getListBrowserStore({
  name: "banks-browser",
  filterDefinitions: [
    {
      name: "partnerName",
      caption: "Partner.Name",
      type: "text"
    },
    {
      name: "uniqueId",
      caption: "Partner.UniqueID",
      type: "text"
    }
  ],
  orderByFields: [
    {
      caption: "Partner.UniqueID",
      value: "UniqueId"
    },
    {
      caption: "Partner.Name",
      value: "PartnerName"
    }
  ],
  pager: {
    orderBy: "PartnerName",
    direction: "asc"
  }
});

const BankListBrowser = ({ params }) => {
  const getBankListFetchingOptions = useMemo(() => {
    return {
      queryOptions: {
        query: PARTNER_LIST_QUERY,
        name: "partners",
        fetchPolicy: "network-only",
        variables: { filters: { partnerTypeId: params.bankTypeId } }
      }
    };
  }, [params.bankTypeId]);

  useApolloFetching(bankListStore, getBankListFetchingOptions);
  const { textResolver } = useListBrowserFunctions();

  return (
    <Card icon={ListIcon}>
      <ListBrowser store={bankListStore} ItemComponent={ListItem} textResolver={textResolver} />
    </Card>
  );
};

BankListBrowser.propTypes = {
  params: PropTypes.object.isRequired
};

export default withParams(BankListBrowser);
